import React from "react";
import { Link } from "react-router-dom";
import Table from "../../ui/Table/Table";
import Checkbox from "../../ui/Checkox/Checkbox";
import { teaserListDetail } from "../../utils/urls";
import plural from "../../utils/plural";
import spaceint2 from "../../utils/spaceint2";

import useSort from "../../hooks/useSort";

const renderSpaceint2 = ({ data, columnInfo }) => (
  <span>{spaceint2(data[columnInfo.accessor])}</span>
);
const renderSummarySpaceint2 = ({ summaryInfo, summary }) => (
  <span>{spaceint2(summary[summaryInfo.accessor] || 0)}</span>
);

const summaryColumns = [
  {},
  {
    title: "Итого",
    colSpan: 3,
    className: "table__border-right"
  },
  {
    accessor: "bid"
  },
  {
    accessor: "bid_2"
  },
  {
    accessor: "clicks",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "clicks_2",
    renderCell: renderSummarySpaceint2
  }
];

const NewsTable = ({
  onCheck,
  onGlobalCheck,
  stat,
  summary,
  checked,
  allChecked,
  loading
}) => {
  const { sortBy, sortOrder, onSortChange } = useSort("id1", "asc");

  const columns = [
    {
      title: "ID",
      accessor: "id",
      renderHeaderCell: ({}) => {
        return (
          <span className="news-table__global-check">
            <Checkbox
              id="global"
              onChange={e => {
                onGlobalCheck({ checked: e.target.checked });
              }}
              checked={allChecked}
            />
            <span>ID</span>
          </span>
        );
      },
      renderDataCell: ({ data }) => {
        return (
          <span className="news-table__global-check">
            <Checkbox
              id={`news-${data.tid}`}
              onChange={e => {
                onCheck({ id: data.tid, checked: e.target.checked });
              }}
              checked={checked.includes(data.tid)}
            />
            <span>
              <Link to={teaserListDetail(data.tid)} className="news-table__id">
                {data.tid}
              </Link>
            </span>
          </span>
        );
      }
    },
    {
      title: "Заголовок",
      accessor: "title"
    },
    {
      title: "Кампания",
      accessor: "campaign_name"
    },
    {
      title: "В открутке",
      accessor: "days",
      dataClassName: "table__border-right",
      className: "table__border-right",
      renderDataCell: ({ data }) => (
        <span>
          {data["days"]} {plural(data["days"], ["день", "дня", "дней"])}
        </span>
      )
    },
    {
      title: "BID (1)",
      accessor: "bid"
    },
    {
      title: "BID (2)",
      accessor: "bid_2"
    },
    {
      title: "Переходы (1)",
      accessor: "clicks",
      renderDataCell: renderSpaceint2
    },
    {
      title: "Переходы (2)",
      accessor: "clicks_2",
      renderDataCell: renderSpaceint2
    }
  ];

  return (
    <div>
      <Table
        columns={columns}
        data={stat}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
        summary={summary}
        summaryColumns={summaryColumns}
        loading={loading}
      />
    </div>
  );
};

export default NewsTable;
